exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cancelReasonWrapper .hasNoReason[data-v-2a226049]{padding:10px;background:#fee;border-radius:4px}.cancelReasonWrapper .reasonSection[data-v-2a226049]{margin-bottom:30px}.cancelReasonWrapper .reasonSection[data-v-2a226049]:last-child{margin-bottom:0}.cancelReasonWrapper .reasonSection .reasonTitle[data-v-2a226049]{margin-bottom:3px;font-weight:700}.cancelReasonWrapper .reasonSection .reasonContent[data-v-2a226049]{white-space:pre-wrap;line-height:1.5}", ""]);

// exports
